module.exports = __webpack_public_path__ + "static/media/play-left-gun.0d9e3685.png";